import { Stack, Typography, useTheme } from "@mui/material";

import { RHFTextField, LocationSelector } from "@app/components";
import { useResponsive } from "@app/hooks";

import { editProfilesFields } from "../edit-profiles-fields";

const ProfileForm = () => {
  const isMobile = useResponsive("down", "sm");
  const theme = useTheme();

  return (
    <Stack
      spacing={3}
      sx={{
        p: { xs: 1, sm: 3, md: 5 },
        border: `1px solid ${theme.palette.grey[200]}`,
        borderRadius: 2,
      }}
    >
      <Stack>
        {editProfilesFields?.map((group, rowIndex) => (
          <Stack
            key={rowIndex}
            direction={isMobile ? "column" : "row"}
            justifyContent={isMobile ? "flex-start" : "space-between"}
            flexWrap="wrap"
            sx={{
              width: "100%",
              gap: 2,
            }}
          >
            {group?.map((field) => (
              <Stack
                key={field?.name}
                spacing={2}
                flex={1}
                sx={{
                  width: "100%",
                  mt: 1,
                }}
              >
                <Typography
                  variant="subtitle2"
                  sx={{
                    fontFamily: "Work Sans",
                    fontWeight: 600,
                    color: theme.palette.grey[900],
                  }}
                >
                  {field?.label}
                </Typography>
                <RHFTextField
                  name={field?.name}
                  placeholder={field?.placeholder}
                  type={field?.type}
                  sx={{
                    width: "100%",
                    minWidth: isMobile ? "100%" : 420,
                    "& .MuiOutlinedInput-root": {
                      height: 50,
                      borderRadius: 1.5,
                      backgroundColor: theme.palette.grey[100],
                      "& fieldset": {
                        border: "none",
                      },
                    },
                  }}
                />
              </Stack>
            ))}
          </Stack>
        ))}
      </Stack>
      <Stack>
        <LocationSelector variant="userInfo" />
      </Stack>
    </Stack>
  );
};

export { ProfileForm };
